import React from 'react';
import MateriaisPopover from '../../../../detail/components/MateriaisPopover';
import AreaTipoDivergenciaEnum from '../../../AreaTipoDivergenciaEnum';
import FinalStepTemplate, {
  useBuildDefaultInfoComponent,
} from '../../../template/FinalStepTemplate';
import useBuildSubmitHandler from '../../../template/UseBuildSubmitHandler';
import {
  transforSelectItemToDivergenciaInfo,
} from '../../../template/utils';
import TipoDivergenciasKey from '../../../TipoDivergenciasKey';
import {
  TipoDivergenciaComponent
} from '../../../TiposDeDivergencias';
import { AjuesteNecessidadeMP } from '../ajuste-necessidade-mp'
import { MateriaisTemplateProps } from '../../../template';

import { loader } from 'graphql.macro';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

const produtoQuery = loader('../../../../../../product-detail/divergencias/queries/getProdutoPPOP.gql')

const AjusteNecessidadeMPFinalStep: TipoDivergenciaComponent<MateriaisTemplateProps> = ({
  onSetStep,
  onBack,
  payload,
}) => {

  const onBackHandler = () => {
    onBack({
      component: AjuesteNecessidadeMP as TipoDivergenciaComponent,
    });
  };

  const { idProducaoPppOp } = useParams<{ idProducaoPppOp: string }>();

  const marcasReserva = [80, 81, 82, 83];
  let areaTipoDivergencia = AreaTipoDivergenciaEnum.AJUSTE_MATERIA_PRIMA;

  type itemProducaoPPPOPQuery = {
    id_ordem_producao: number;
    Producao_Prog_Prod: {
      Produto_Cor: {
        Produto: {
          id_produto: number;
          produto: string;
          Marca: {
            id_marca: number;
            id_marca_linx: number;
            marca: string;
          }
        };
      };
    };
  };

  const { data } = useQuery<{
    findOneProducao_PPP_OP: itemProducaoPPPOPQuery;
  }>(produtoQuery, {
    variables: {
      idProducaoPppOp: parseInt(idProducaoPppOp, 10),
    },
  });

  if (data) {
    const marca = data.findOneProducao_PPP_OP.Producao_Prog_Prod?.Produto_Cor?.Produto?.Marca?.id_marca_linx;
    if (marca && marcasReserva.includes(marca)) {
      areaTipoDivergencia = AreaTipoDivergenciaEnum.CONTROLE_PCP;
    }
  }

  const infoComponents = [
    ...useBuildDefaultInfoComponent(
      areaTipoDivergencia,
      'Ajuste de necessidade de MP'
    ),
    <MateriaisPopover
      materiais={payload.materiais.map(transforSelectItemToDivergenciaInfo)}
    ></MateriaisPopover>,
  ];

  const key = TipoDivergenciasKey.AJUSTE_DE_NECESSIDADE_DE_MP;
  const {
    loadingSave,
    loadingTipoDivergencia,
    handleSubmit,
  } = useBuildSubmitHandler(key, onSetStep);

  return (
    <FinalStepTemplate
      loading={loadingSave || loadingTipoDivergencia}
      onBack={onBackHandler}
      onSetStep={(step) => {
        handleSubmit(
          step, [
          ...payload.materiais.map((item) => ({
            tipo: item.tipo,
            value: item.id.toString(),
            adicionalInfo: item.adicionalInfo,
            material: item.material
          }))
        ]
        );
      }}
      progressValue={90}
      stepNumber={'4'}
      infoComponents={infoComponents}
    />
  );
};

export default AjusteNecessidadeMPFinalStep;
